import { createReducer, on } from '@ngrx/store';
import { ImpersonationActions } from '@ps/auth-data-access';
import { BulkEditActions, BulkEditApiActions } from '../bulk-edit.actions';
import { INITIAL_BULK_OPERATION_STATE } from '../../survey-state.constants';

export const bulkOpeartionReducer = createReducer(
  INITIAL_BULK_OPERATION_STATE,
  on(BulkEditActions.setSelectedSurveys, (state, { selected }) => ({
    ...state,
    ...(selected.length ? { selected } : INITIAL_BULK_OPERATION_STATE),
  })),
  on(BulkEditActions.resetSelectedSurveys, () => ({
    ...INITIAL_BULK_OPERATION_STATE,
  })),
  on(BulkEditActions.setBulkOperation, (state, { operation }) => ({
    ...state,
    operation,
  })),
  on(BulkEditApiActions.loadBulkStatsSuccess, (state, { stats }) => ({
    ...state,
    stats,
  })),
  on(ImpersonationActions.contextSettled, () => INITIAL_BULK_OPERATION_STATE),
);
